// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsSiteAccountV2PatientsPatientAccountModel {
    static getAttributeTypeMap() {
        return ScriptsSiteAccountV2PatientsPatientAccountModel.attributeTypeMap;
    }
}
ScriptsSiteAccountV2PatientsPatientAccountModel.discriminator = undefined;
ScriptsSiteAccountV2PatientsPatientAccountModel.additionalProperties = false;
ScriptsSiteAccountV2PatientsPatientAccountModel.attributeTypeMap = [
    {
        "name": "account",
        "baseName": "account",
        "type": "AccountModel"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "PatientModel"
    },
];
//# sourceMappingURL=scriptsSiteAccountV2PatientsPatientAccountModel.js.map